import React from 'react';
import { AdLabelProps } from '../types';
import { AdLabelIcon } from './ad-label-icon';
import { AdData } from 'common/components/ad-data';
import { HintWrapper } from 'common/components/hint-wrapper';
import { AdLabelLegalDataWrapperStyles } from '../styles';
export const AdLabel: React.FC<AdLabelProps> = props => {
  const { variant = 'text', ord, className, toggleModal, isMobileView = false } = props;



  return (
    <HintWrapper
      toggleModal={toggleModal}
      isMobileView={isMobileView}
      anchor={<AdLabelIcon {...{ variant, className }} />}
      dataQa="banner-carousel/hint"
      placement="bottom">
      <AdData className={AdLabelLegalDataWrapperStyles} {...{ ord }} />
    </HintWrapper>
  );
};
